export default __webpack_public_path__ + "static/media/ECE-graf-PLA-FIX-cat--3.ef07a1f3.png";